import script from "./ComboboxPaginado.vue?vue&type=script&setup=true&lang=js"
export * from "./ComboboxPaginado.vue?vue&type=script&setup=true&lang=js"

import "./ComboboxPaginado.vue?vue&type=style&index=0&id=3fdd9ddb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fdd9ddb"]])

export default __exports__